<script>
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'

export default {
  name: 'FundraiserOldListGroupItem',
  components: { TwLoadingSpinner, TwButton },
  props: {
    oldFundraiser: {
      type: Object,
      required: true
    },
    organization: {
      type: Object,
      required: true
    },
    fundraiser: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      LoadingImportingFundraiser: false,
    }
  },
  methods: {
    async importFundraiser() {
      try {
        if(confirm('Import Fundraiser? This will import all the support fundraisers, users, and donations. Any changes made locally will be removed.')) {
          this.ValidationErrorMessage = null
          this.LoadingImportingFundraiser = true
          const { data } = await axios.post(`/api/v1/import/old-fundraiser/${this.oldFundraiser.id}/import`, {
            organization_id: this.organization.id
          })
          useFundraiserStore().itemPatchState(data)
          this.LoadingImportingFundraiser = false
        }
      } catch (e) {
        console.error(e)
        this.LoadingImportingFundraiser = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <div class="bg-gray-50 border-green-200 p-4">
    <tw-loading-spinner v-if="LoadingImportingFundraiser">
      Importing...
    </tw-loading-spinner>
    <tw-button class="float-right" :variant="fundraiser? 'success':'primary'" :loading="LoadingImportingFundraiser" @click="importFundraiser">
      <span v-if="fundraiser"> Re-import </span>
      <span v-else> Import </span>
    </tw-button>
    <h3> {{ oldFundraiser.title }} </h3>
    <p> {{ oldFundraiser.short_desc }} </p>
    <p>Goal: ${{ oldFundraiser.goal }} ,raised ${{ oldFundraiser.raised_cache }}  </p>
  </div>
</template>

<style scoped>

</style>
